import '../../style/index.less';
import '../../popover/style';



// WEBPACK FOOTER //
// ./_antd1.11.2/popconfirm/style/index.js